<div data-test-id="localSelect" fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center" style="flex: 1;" >
  <header>
    <mat-icon data-test-id="icon" fxFlexAlign="center" *ngIf="showIcon">language</mat-icon>
    <!-- The Angular Model here is directly piped to the i18nService -->
    <mat-select data-test-id="input" [hideSingleSelectionIndicator]="true" (selectionChange)="onChange($event)" [value]="this.i18nService.selectedLocaleId">
      <mat-option data-test-id="option" *ngFor="let localeId of localesIds" [value]="localeId">
        {{ localesListMap.get(localeId) }}
      </mat-option>
    </mat-select>
  </header>
</div>
